module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/playground.json
// module id = 967
// module chunks = 211528014387745